import instance from "./api";

export const fetchDriverProfile = (id) =>
  instance.get(`/dashboard/profile-driver?id=${id}`).then((r) => r.data);
